import { ReactElement, useEffect } from 'react';
import { Field, useFormikContext, getIn } from 'formik';
import { TextInput, TileRadio, EmailFieldWithExperian, ContactInputWithExperian, AddressField, LimitedTextArea } from '@components';
import { tile } from '@interfaces/interfaces';
import { iFVSFormValues } from '@services/FVSService';
import { FormType } from '@constants/forms';

function FVSStep14(): ReactElement {
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const RepresentativeRequestsEmailCopy = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );
  const RepresentativeDeclinesEmailCopy = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );
  const RepresentativeEmailCopyBool: tile[] = [
    {
      body: <RepresentativeRequestsEmailCopy />,
      value: 'Yes',
    },
    {
      body: <RepresentativeDeclinesEmailCopy />,
      value: 'No',
    },
  ];
  const RepresentativeAllowsPhoneCommunication = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );
  const RepresentativeDeclinesPhoneCommunication = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );
  const RepresentativePhoneCommunicationBool: tile[] = [
    {
      body: <RepresentativeAllowsPhoneCommunication />,
      value: 'Yes',
    },
    {
      body: <RepresentativeDeclinesPhoneCommunication />,
      value: 'No',
    },
  ];
  useEffect(() => {
    if (getIn(values, 'saveEmail') !== '') {
      values.RepresentativeEmailAddress = getIn(values, 'saveEmail');
    }
  }, [getIn(values, 'saveEmail')]);
  return (
    <>
      <div className="vfH2">Your details (authorised representative)</div>
      <p className="subHeadingH3">We need your details here. We'll ask you for the details of the person affected by family violence later.</p>
      <p>
        All fields within this form are required unless marked as
        <em> optional.</em>
      </p>
      <Field component={TextInput} name="RepresentativeGivenName" title="Given name(s)" isMandatory />
      <Field component={TextInput} name="RepresentativeFamilyName" title="Family name" isMandatory />
      <Field component={TextInput} name="RepresentativeRelationshipToVictim" title="Relationship to person affected by the family violence" isMandatory />
      <Field component={TextInput} name="RepresentativeCompanyName" title="Organisation / company name" />
      <Field component={TextInput} name="RepresentativeCompanyPosition" title="Position in organisation / company" />
      <AddressField name="RepresentativePostalAddress" title="Postal address" manualAddressText="Enter the address manually" isMandatory />
      <Field component={EmailFieldWithExperian} name="RepresentativeEmailAddress" title="Email" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.FAMILYVIOLENCESCHEME} noEmailField="NoEmailAddress" currentSP="Select if they do not have an email address" noEmailFieldRequired={false} warningMessage="RepresentativeEmailAddressWarning" />
      <div>
        <Field
          component={TileRadio}
          name="RepresentativeRequestsEmailCopyBool"
          title="Would you like to receive a copy of the completed application at your email address?"
          tileData={RepresentativeEmailCopyBool}
          tileContainer
          isMandatory
          orientationRow
        />
      </div>
      <Field component={ContactInputWithExperian} name="FVSContactNumber" title="Contact phone number" isMandatory orientationRow obligationNumber={values.OBLIGATION_NUMBER} formName={FormType.FAMILYVIOLENCESCHEME} secondaryContact={false} hasPrimaryNumberType={false} warningMessage="FVSContactNumberWarning" />
      <div>
        <Field
          component={TileRadio}
          name="RepresentativeAllowsPhoneCommunicationBool"
          title="Can we phone you regarding this application?"
          tileData={RepresentativePhoneCommunicationBool}
          tileContainer
          isMandatory
          orientationRow
        />
      </div>
      {values.RepresentativeAllowsPhoneCommunicationBool === 'Yes' && (
        <Field
          component={LimitedTextArea}
          name="RepresentativePreferredContactDayTime"
          title="What are the best days and times to phone? (400 characters maximum)"
          limit={400}
          isMandatory
        />
      )}
    </>
  );
}
export default FVSStep14;
